import styles from './styles/Button.expandHierarchyLvl.module.scss';
import React from 'react';
import { Ssvg } from '../../../Components/react/Ssvg';
export const ButtonExpandHierarchyLvl = ({ className = '', expanded, onClick }) => (React.createElement("button", { className: `btn:cleared h:100p d:flex ai:center jc:center ${styles.button} ${className}`, "aria-expanded": expanded, onClick: onClick },
    React.createElement(Ssvg, { icon: "#icon--arrow-down", className: `trs:all:300 ${styles.icon}` })));
